import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { AppProviders, createAppRouter } from "@empite/app-kit";
import "@empite/ui-components/styles.css";
import "./portal.css";
import { appContext } from "./boot";
import { routeTree } from "./routes";

// The router, like the QueryClient and the transport it is handed, is built
// once at module scope — see src/boot.ts for why.
const router = createAppRouter({ routeTree, context: appContext });

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html is missing #root");
}

createRoot(root).render(
  <StrictMode>
    {/* AppProviders puts the QueryClient and the transport in context. This
        portal reads neither through @empite/session's hooks — those are the
        customer SSO surface and would call /v1 with a cookie this realm does
        not hold — it reads through src/admin-hooks.ts, which talks only to
        /admin/v1. */}
    <AppProviders queryClient={appContext.queryClient} transport={appContext.transport}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
